module.exports = __webpack_public_path__ + "img/sales-order-to-purchase-order.cf60b2d4.svg";